import { __assign, __rest } from "tslib";
import React from "react";
import classNames from "classnames";
import { useConfig } from "../_util/config-context";
import { forwardRefWithStatics } from "../_util/forward-ref-with-statics";
var wrapAdornmentAddon = function (addon, classPrefix) { return (React.createElement("div", { className: classPrefix + "-input-group__addon" }, addon)); };
var wrapAdornmentText = function (text, pure, classPrefix) { return (React.createElement("span", { className: pure
        ? classPrefix + "-form__help-text--inline"
        : classPrefix + "-input-group__text" }, text)); };
export var InputAdornment = forwardRefWithStatics(function InputAdornment(_a, ref) {
    var before = _a.before, after = _a.after, children = _a.children, appearence = _a.appearence, _b = _a.appearance, appearance = _b === void 0 ? appearence : _b, className = _a.className, props = __rest(_a, ["before", "after", "children", "appearence", "appearance", "className"]);
    var classPrefix = useConfig().classPrefix;
    if (typeof before === "string") {
        // eslint-disable-next-line no-param-reassign
        before = wrapAdornmentText(before, false, classPrefix);
    }
    if (typeof after === "string") {
        // eslint-disable-next-line no-param-reassign
        after = wrapAdornmentText(after, appearance === "pure", classPrefix);
    }
    return (React.createElement("div", __assign({ ref: ref, className: classNames(classPrefix + "-input-group", className) }, props),
        before && wrapAdornmentAddon(before, classPrefix),
        children,
        after && wrapAdornmentAddon(after, classPrefix)));
}, {
    defaultLabelAlign: "middle",
});
InputAdornment.displayName = "InputAdornment";
/**
 * @deprecated
 *
 * 请使用 InputAdornment 代替
 */
export var InputAdorment = InputAdornment;
//# sourceMappingURL=InputAdornment.js.map